import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from '@angular/synthrone-design/services';

@Component({
  selector: 'pipelines-view',
  templateUrl: './pipelines-view.component.html',
  styleUrls: ['./pipelines-view.component.scss']
})

export class PipelinesViewComponent implements OnInit {

  @ViewChild('pipelinesTable') pipelinesTable;

  configColumns = {
    id: {
      label: "Id",
      sortable: true,
      truncate: true,
      style:{
          flexGrow: 0.20
      }
    },
    name: {
      label: "Name",
      sortable: true,
      truncate: true
    },
    description: {
      label: "Description",
      sortable: true,
      truncate: true
    },
    created: {
      label: "Created",
      sortable: true,
      truncate: true,
      type: "time",
      style:{
          flexGrow: 0.5
      }
    },
    updated: {
      label: "Updated",
      sortable: true,
      truncate: true,
      type: "time",
      style:{
          flexGrow: 0.5
      }
    },
    "platform_pipelines.length": {
      label: "Number of platforms",
      sortable: true,
      style:{
          flexGrow: 0.50
      }
    },
    "stage_pipeline.length": {
      label: "Number of stages",
      sortable: true,
      style:{
          flexGrow: 0.50
      }
    }
  };

  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  timeout = null;
  tableFilter = {
      'search': ''
  } 

  constructor(private router: Router, private route: ActivatedRoute, protected api: ApiService, public dialog: MatDialog, private sanitizer:DomSanitizer) { 
  }

  ngOnInit() {
    this.tableFilter = {
        'search': (typeof this.queryParams['search'] === "undefined") ? this.tableFilter.search : this.queryParams['search']
    }
  }

  setParams = () => {
      this.queryParams['search'] = this.tableFilter.search;
  }

  refreshTable = () => {
      this.pipelinesTable.getData()
  }

  breadcrumbsFN = () => {
    return Observable.of([
      {
        breadcrumb: 'ADMINER',
        url: '/'
      },
      {
        breadcrumb: 'Pipelines',
        url: '/pipelines'
      }
    ]);
  }

  sdPipelines = (limit, offset, sortBy, sortOrder): Observable<any> => {
    return this.api.makeRequest('api_pipeline_system_list', {
        seed: new Date().getTime(),
        offset: offset,
        limit: limit,
        sortBy: 'id',
        sortOrder: sortOrder,
        filterValue: this.tableFilter.search
      }, 'publisher').flatMap(results => {
        results['data'].forEach(result => {
          if (result.hasOwnProperty('description')) {
            let html = this.sanitizer.bypassSecurityTrustHtml('<div class="show-tooltip">' + result['description'] + '</div><div class="table-tooltip">'+result['description']+'</div>');
            result['description'] = html;
          }
        });
        return Observable.of(results);
      });
  }

  editRow = (key) => {
    this.router.navigate(['/pipelines/edit', key]);
  }

  add = () => {
    this.router.navigate(['/pipelines/add']);
  };

  searchProductFN = () => {
   
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setParams();
        this.router.navigate(['/pipelines/1/10/'], { relativeTo: this.route, queryParams: this.queryParams });
        this.refreshTable();
      }, 2000);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/pipelines-view/pipelines-view.component.ts